import { getToken, HEADER_PREFIX } from 'utils/auth'

async function token() {
  const userToken = await getToken()
  return userToken ? `${HEADER_PREFIX} ${userToken}` : 'None'
}

export async function downloadFetchResponse(res, filename) {
  try {
    const blob = await res.blob()

    const newBlob = new Blob([blob], { type: blob.type })

    // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob)
    } else {
      // For other browsers: create a link pointing to the ObjectURL containing the blob.
      const objUrl = window.URL.createObjectURL(newBlob)

      const link = document.createElement('a')
      link.href = objUrl
      link.download = filename || 'form.pdf'
      link.click()

      // For Firefox it is necessary to delay revoking the ObjectURL.
      setTimeout(() => {
        window.URL.revokeObjectURL(objUrl)
      }, 250)
    }
  } catch (error) {}
}

export async function downloadFetchResponseZip(res, filename) {
  try {
    const newBlob = await res.blob()

    // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob)
    } else {
      // For other browsers: create a link pointing to the ObjectURL containing the blob.
      const objUrl = window.URL.createObjectURL(newBlob)

      const link = document.createElement('a')
      link.href = objUrl
      link.download = filename || 'form.zip'
      link.click()

      // For Firefox it is necessary to delay revoking the ObjectURL.
      setTimeout(() => {
        window.URL.revokeObjectURL(objUrl)
      }, 250)
    }
  } catch (error) {}
}

export async function downloadFromURL(filePath, fileName) {
  const xhr = new XMLHttpRequest()
  xhr.open('GET', filePath, true)
  xhr.responseType = 'blob'
  xhr.setRequestHeader('Authorization', await token())
  xhr.onload = function () {
    const urlCreator = window.URL || window?.webkitURL
    const imageUrl = urlCreator.createObjectURL(this.response)
    const tag = document.createElement('a')
    tag.href = imageUrl
    tag.download = fileName || 'zentake'
    document.body?.appendChild?.(tag)
    tag.click()
    document.body?.removeChild?.(tag)
  }
  await xhr.send()
}
